import { Box, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import { format } from "date-fns";
import RoundedTable from "@entrilia/shared/components/RoundedTable";
import { formatMoney, formatNumber } from "@entrilia/shared/utilities/formatters";
import type { LocaleInfo } from "@entrilia/shared/utilities/userLocaleConfig";

interface Props {
  selectedLocale: LocaleInfo;
}

const exampleNumber = 1234.56;
const exampleDateTime = new Date(`${new Date().getFullYear()}-01-25T15:30:45`);

const ExampleFormattingTable = ({ selectedLocale }: Props) => {
  const selectedDateFnsLocale = selectedLocale.locale;
  const selectedLocaleCode = selectedLocale.locale.code;

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ py: 1 }}>
        Example Formatting
      </Typography>
      <RoundedTable>
        <TableBody>
          <TableRow>
            <TableCell width="112">
              <Typography color="textSecondary">Date (long)</Typography>
            </TableCell>
            <TableCell width="auto">{format(exampleDateTime, "PP", { locale: selectedDateFnsLocale })}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell width="112">
              <Typography color="textSecondary">Date (short)</Typography>
            </TableCell>
            <TableCell width="auto">{format(exampleDateTime, "P", { locale: selectedDateFnsLocale })}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell width="112">
              <Typography color="textSecondary">Time</Typography>
            </TableCell>
            <TableCell width="auto">{format(exampleDateTime, "p", { locale: selectedDateFnsLocale })}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell width="112">
              <Typography color="textSecondary">Number</Typography>
            </TableCell>
            <TableCell width="auto">{formatNumber(exampleNumber, undefined, selectedLocaleCode)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell width="112">
              <Typography color="textSecondary">Currency</Typography>
            </TableCell>
            <TableCell width="auto">{formatMoney(exampleNumber, "USD", undefined, selectedLocaleCode)}</TableCell>
          </TableRow>
        </TableBody>
      </RoundedTable>
    </Box>
  );
};

export default ExampleFormattingTable;
